import { useEffect, useRef, useState } from 'react';

export const useDraggablePosition = (draggable = true) => {
  const [position, setPosition] = useState({ top: 90, left: 400 });
  const dragRef = useRef(null);
  const isDragging = useRef(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  const requestAnimationRef = useRef();

  const handleMouseDown = (e) => {
    if (!draggable) return;
    isDragging.current = true;
    dragOffset.current = {
      x: e.clientX - position.left,
      y: e.clientY - position.top,
    };
  };

  useEffect(() => {
    const centerDiv = () => {
      if (dragRef.current) {
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;

        const divHeight = dragRef.current.offsetHeight;
        const divWidth = dragRef.current.offsetWidth;

        // Calculate the top and left position considering the modal dimensions
        const top = (windowHeight - divHeight) / 2;
        const left = (windowWidth - divWidth) / 2;

        setPosition({ left, top });
      }
    };

    // Center on initial render
    centerDiv();
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging.current) {
        const newPosition = {
          top: e.clientY - dragOffset.current.y,
          left: e.clientX - dragOffset.current.x,
        };
        requestAnimationRef.current = requestAnimationFrame(() => {
          setPosition(newPosition);
        });
      }
    };

    const handleMouseUp = () => {
      isDragging.current = false;
    };
    if (draggable) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      cancelAnimationFrame(requestAnimationRef.current);
    };
  }, [draggable]);

  return { dragRef, handleMouseDown, position };
};
